import React, { useEffect, useState } from "react";
import fetchProductsAction from "@pillvery/redux/products/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import ProductsListTable from "../Listing/Products/ProductsListTable";
import PillveryPagination from "../../components/PillveryPagination";

const { fetchProducts } = fetchProductsAction;

export default function BestSellingProducts({ cardWidth }) {
  const dispatch = useDispatch();
  const { products, loading, productDeleted } = useSelector(
    (state) => state.Products
  );
  const history = useHistory();
  const location = useLocation();
  const currentUrlParams = new URLSearchParams(location.search);
  const [params, setParams] = useState({
    page: parseInt(currentUrlParams.get("page")) || 1,
    limit: 6,
    sort_type: "desc",
    sort_field: "quantity_sold",
  });

  useEffect(() => {
    dispatch(fetchProducts(params));
  }, [productDeleted]);

  const pagination = {
    total: products?.total_count,
    pageSize: params.limit,
    activePage: params.page,
  };

  function handlePageChange(pageNumber) {
    currentUrlParams.set("page", pageNumber);
    history.push(location.pathname + "?" + currentUrlParams.toString());

    params.page = pageNumber;

    dispatch(fetchProducts(params));
  }

  return (
    <div className="col-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-start justify-content-between">
            <p className="card-title flex-grow">Best Selling Products</p>
            {/* <div className="dropdown dropright card-menu-dropdown">
                            <button className="btn" type="button" id="cardMenuButton6"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="mdi mdi-dots-horizontal card-menu-btn"></i>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="cardMenuButton6">
                                <a className="dropdown-item" href="#">Action</a>
                                <a className="dropdown-item" href="#">Another action</a>
                                <a className="dropdown-item" href="#">Something else here</a>
                            </div>
                        </div> */}
          </div>
          <PillveryPagination
            pagination={pagination}
            onPageChange={handlePageChange}
          />
          <ProductsListTable
            products={products.data}
            loading={loading}
            report={true}
            params={params}
          />
          <PillveryPagination
            pagination={pagination}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}
